import { LinkProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import RouteLink from '@/components/RouteLink';
import { RegistryPackage } from '@/graphql/upbound-graphql';

const TabTriggerLink: React.FC<
  PropsWithChildren<Omit<LinkProps, 'href'> & { data: RegistryPackage; append: string }>
> = ({ children, data, append, ...props }) => {
  return (
    <RouteLink
      to="packageDetails"
      append={append}
      params={{
        packageType: data.packageType,
        packageOwner: data.account,
        packageName: data.name,
        packageVersion: data.version,
      }}
      scroll={false}
      shallow={true}
      {...props}
    >
      {children}
    </RouteLink>
  );
};

export default TabTriggerLink;
